import { render, staticRenderFns } from "./GraficoBarDashboardTarefas.vue?vue&type=template&id=68171caa"
import script from "./GraficoBarDashboardTarefas.vue?vue&type=script&lang=js"
export * from "./GraficoBarDashboardTarefas.vue?vue&type=script&lang=js"
import style0 from "./GraficoBarDashboardTarefas.vue?vue&type=style&index=0&id=68171caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports